
import addPrefix from 'bwax-ui/addPrefix'


export default addPrefix('design', {

})